// Fix for StickyHeader errors - Ultra-aggressive mode
(function() {
  // Global error handler to catch and suppress common errors
  const originalError = window.onerror;
  window.onerror = function(message, source, lineno, colno, error) {
    if (message && (
      message.includes('Cannot read properties of null') ||
      message.includes('closeSearchModal') ||
      message.includes('searchModal') ||
      message.includes('Content Security Policy') ||
      message.includes('frame-ancestors')
    )) {
      // Silently suppress these errors
      return true; // Prevent error from showing
    }
    if (originalError) {
      return originalError.apply(this, arguments);
    }
    return false;
  };
  
  // Suppress CSP warnings in console
  const originalConsoleError = console.error;
  console.error = function(...args) {
    const message = args.join(' ');
    if (message.includes('Content Security Policy') || 
        message.includes('frame-ancestors') ||
        message.includes('Refused to frame')) {
      // Suppress CSP warnings
      return;
    }
    originalConsoleError.apply(console, args);
  };
  
  // Apply fix immediately
  function applyStickyHeaderFix() {
    if (window.StickyHeader) {
      // Safely patch closeSearchModal method to fix "Cannot read properties of null" error
      if (typeof window.StickyHeader.prototype.closeSearchModal === 'function') {
        const originalCloseSearchModal = window.StickyHeader.prototype.closeSearchModal;
        window.StickyHeader.prototype.closeSearchModal = function() {
          try {
            // Check if this.searchModal exists and has close method before calling
            if (this.searchModal && this.searchModal.close && typeof this.searchModal.close === 'function') {
              originalCloseSearchModal.apply(this, arguments);
            }
          } catch (e) {
            // Silently suppress error
            return;
          }
        };
      } else {
        // If the method doesn't exist yet, define it safely
        window.StickyHeader.prototype.closeSearchModal = function() {
          if (this.searchModal && this.searchModal.close && typeof this.searchModal.close === 'function') {
            try {
              this.searchModal.close(false);
            } catch (e) {
              // Silently suppress
            }
          }
        };
      }
      
      // Safely patch hide method
      if (typeof window.StickyHeader.prototype.hide === 'function') {
        const originalHide = window.StickyHeader.prototype.hide;
        window.StickyHeader.prototype.hide = function() {
          try {
            // Call closeSearchModal safely
            if (this.closeSearchModal && typeof this.closeSearchModal === 'function') {
              this.closeSearchModal();
            }
            // Continue with original hide logic (without closeSearchModal call)
            if (this.header) {
              this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
              this.closeMenuDisclosure();
            }
          } catch (e) {
            // Silently suppress
            return;
          }
        };
      }
      
      // Fix existing instances
      document.querySelectorAll('sticky-header').forEach(function(element) {
        if (element.searchModal === null || element.searchModal === undefined) {
          element.searchModal = {
            close: function() {
              // Safe no-op implementation
            }
          };
        }
      });
    } else {
      // If StickyHeader doesn't exist yet, we'll create a placeholder
      window.StickyHeader = window.StickyHeader || function() {};
      window.StickyHeader.prototype.closeSearchModal = function() {
        // Safe implementation
        if (this.searchModal && this.searchModal.close && typeof this.searchModal.close === 'function') {
          try {
            this.searchModal.close(false);
          } catch (e) {
            // Silently suppress
          }
        }
      };
    }
  
  // Fix announcement carousel errors
  const fixCarouselErrors = function() {
    const dots = document.querySelectorAll('.announcement-slider .owl-dot');
    if (dots && dots.length) {
      dots.forEach(dot => {
        if (!dot.hasAttribute('aria-label')) {
          dot.setAttribute('aria-label', 'Slide dot');
        }
      });
    }
  };
  
  // Apply fixes immediately and after a delay
  fixCarouselErrors();
  setTimeout(fixCarouselErrors, 1000);
  }
  
  // Apply fix immediately
  applyStickyHeaderFix();
  
  // Also apply on DOMContentLoaded in case StickyHeader loads later
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyStickyHeaderFix);
  }
})();
